import {
  APPLICATION_TVA_TYPE_EXPORT_HORS_UE,
  APPLICATION_TVA_TYPE_INTRACOMMUNAUTAIRE,
  APPLICATION_TVA_TYPE_NON_APPLICABLE,
} from '@/configuration/applicationTvaConf';

export default function getExonerationTva(tiers) {
  if (!tiers || !tiers.applicationTva) return false;
  return [
    APPLICATION_TVA_TYPE_EXPORT_HORS_UE,
    APPLICATION_TVA_TYPE_INTRACOMMUNAUTAIRE,
    APPLICATION_TVA_TYPE_NON_APPLICABLE,
  ].includes(tiers.applicationTva);
}
